import { useDispatch } from "react-redux"
import { setIsAcess } from "../../redux/actions"

const AuthLogout = (response) => {
  const dispatch = useDispatch()
  // if (response?.status === 403 || response?.status === 401) {
  dispatch(setIsAcess(false))
  localStorage.clear()
  // }
}

export default AuthLogout
